module.exports = __webpack_public_path__ + "media/assets/images/errors-oauth-icon-f4d9f5a7b0e95f4f4008c78aa51e0aee.png";